import { Component } from '@angular/core';


import { CustomizerSettingsService } from "../../customizer-settings/customizer-settings.service";
import { ToggleService } from "../../common/sidebar/toggle.service";
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';

import { FooterComponent } from '../../common/footer/footer.component';
import { HeaderComponent } from '../../common/header/header.component';
import { SidebarComponent } from '../../common/sidebar/sidebar.component';
import { CollegeAdminDashbaordComponent } from '../../college-admin-dashbaord/college-admin-dashbaord.component';


@Component({
  selector: 'app-college-admin-dash-layout',
  standalone: true,
  imports: [
    CommonModule,
    SidebarComponent,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    CollegeAdminDashbaordComponent,

  ],
  templateUrl: './college-admin-dash-layout.component.html',
  styleUrl: './college-admin-dash-layout.component.scss'
})
export class CollegeAdminDashLayoutComponent {
  isSidebarToggled: boolean = false;
  isToggled: boolean = false;



  constructor(
    public router: Router,
    private toggleService: ToggleService,

    public themeService: CustomizerSettingsService
  ) {
    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });


  }

  ngOnInit(): void {
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser") || "{}");
    const userType = currentUser?.userType;


    if (userType === 8 && this.router.url === "/college-admin-dashboard") {
      this.router.navigateByUrl("/college-admin-dashboard/welcome");
    }

  }

}
